<template>
    <list-container 
        :columns="columns" 
        :data="items" 
        :actions="actions" 
        titleKey="ClientName"
        :headerActitonStyle="headerActitonStyle"
        @loadMore="$emit('loadMore')">
    </list-container>
</template>

<script>

import ListContainer from '@/views/app/components/containers/ListContainer.vue';
export default {
    components: { ListContainer },
    props: {
        items: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            columns: [
                { key: 'ClientName', label: 'client'},
                { key: 'gracePeriod', label: 'grace_period'},
            ],
            actions: [
                { tooltip: 'grace_period', icon: 'ClockIcon',permissions:['IU RANGES EDIT'],customClass: 'custom-warning', onClick: row => this.$emit('edit',row) },
                { tooltip: 'range', icon: 'TruckIcon',permissions:['IU RANGES VIEW'],customClass: 'custom-primary', onClick: row => this.details(row) },
            ],
            headerActitonStyle:{ width:'10vw'}
        }
    },
    methods: {
        details(row) {
            this.$router.push({ name: 'warehouse-client-price-detail', params: { client: row.ClientId } })
        },
    }
}
</script>

<style></style>